import View from './Organization';
import enhancer from './Organization.enhancer';

const Organization = enhancer(View);

export default Organization;
